import { render, staticRenderFns } from "./DataCollectionComponent.vue?vue&type=template&id=589bbdba"
import script from "./DataCollectionComponent.vue?vue&type=script&lang=js"
export * from "./DataCollectionComponent.vue?vue&type=script&lang=js"
import style0 from "./DataCollectionComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports